/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioHierarchyRequest extends models.AppSecopsDashboardRequestBase {
    getFixupPrototypeFunction() { return AppSecopsPortfolioHierarchyRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioHierarchyRequest>): AppSecopsPortfolioHierarchyRequest {
        let obj = Object.assign(new AppSecopsPortfolioHierarchyRequest(), model);
        AppSecopsPortfolioHierarchyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioHierarchyRequest>): AppSecopsPortfolioHierarchyRequest {
        if (!model) return null;
        return AppSecopsPortfolioHierarchyRequest.newInstance(<AppSecopsPortfolioHierarchyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioHierarchyRequest) {
        if (!obj) return;

        models.AppSecopsPortfolioHierarchyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioHierarchyRequest): boolean {
        if (models.AppSecopsDashboardRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioHierarchyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
